import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isMobileView } from "../Utility/Utility";

export default function useLastVisited() {
  const location = useLocation();

  useEffect(() => {
    if (isMobileView) {
      // Do not overwrite last page when PWA launches
      if (window.location.search.includes("pwa=true")) return;

      // Ignore "/" — prevents overriding the real page
      if (location.pathname === "/") return;

      const fullPath = location.pathname + location.search;
      if (fullPath.includes("customercartlist")) {
        localStorage.setItem("lastVisited", "/kansas_product/allproducts");
      } else {
        localStorage.setItem(
          "lastVisited",
          fullPath.startsWith("/") ? fullPath : `/${fullPath}`,
        );
      }
    }
  }, [location]);
}
